export const COLORS = {
  primary: '#00568e',
  lightBlue: '#c4e4e0',
  white: '#fff',
  gray: '#324755',
  grayText: '#98a3aa',
  red: '#d13f59',
  greenMuuControl: '#73b650',
  errorMuuControl: '#fe3906'
};
